import { render } from "./CasesByInsuranceType.vue?vue&type=template&id=6fc82f4c&scoped=true"
import script from "./CasesByInsuranceType.vue?vue&type=script&lang=js"
export * from "./CasesByInsuranceType.vue?vue&type=script&lang=js"

import "./CasesByInsuranceType.vue?vue&type=style&index=0&id=6fc82f4c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc82f4c"]])

export default __exports__